/** JWT for platform-level API calls (super admin / multi-business manager), not the switched-business Admin token. */
export function getPlatformAuthToken(): string | null {
  const impersonating = localStorage.getItem('impersonatingBusiness') === 'true';
  const inBusinessContext = localStorage.getItem('inBusinessContext') === 'true';
  if (impersonating) {
    return localStorage.getItem('superAdminToken') || localStorage.getItem('token');
  }
  if (inBusinessContext) {
    return localStorage.getItem('multiBusinessManagerToken') || localStorage.getItem('token');
  }
  return localStorage.getItem('token');
}

export function getPrincipalRoleFromToken(): string | null {
  try {
    const token = getPlatformAuthToken();
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.actualRoleName || payload.role || null;
  } catch {
    return null;
  }
}

export function isMultiBusinessManagerPrincipal(): boolean {
  return getPrincipalRoleFromToken() === 'Multi Business Manager';
}
